module.exports = __webpack_public_path__ + "static/media/vf_wsneakers_core.c209cb8b.svg";